import { adminCall, adminGet, adminRequest } from '../../api/adminCall';

export async function createCustomPlan({ customerLabel, terms }) {
  return adminCall('/api/admin/custom-plans', { customerLabel, terms });
}

export async function updateCustomPlan({ planId, customerLabel, terms }) {
  return adminRequest(`/api/admin/custom-plans/${encodeURIComponent(planId)}`, {
    method: 'PUT',
    body: { customerLabel, terms },
  });
}

export async function getCustomPlan({ planId }) {
  return adminGet(`/api/admin/custom-plans/${encodeURIComponent(planId)}`);
}

export async function listCustomPlans({ status = 'all' } = {}) {
  const data = await adminGet(`/api/admin/custom-plans?status=${encodeURIComponent(status || 'all')}`);
  return data.plans || [];
}

export async function sendCustomPlanInvite({ planId, email }) {
  return adminCall(`/api/admin/custom-plans/${encodeURIComponent(planId)}/invite`, { email });
}

export async function resendCustomPlanInvite({ planId }) {
  return adminCall(`/api/admin/custom-plans/${encodeURIComponent(planId)}/resend`);
}

export async function cancelCustomPlanInvite({ planId, revertToDraft = true }) {
  return adminCall(`/api/admin/custom-plans/${encodeURIComponent(planId)}/cancel`, { revertToDraft });
}
